import { useEffect, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { supabase } from '@/lib/supabase';

/**
 * This component handles OAuth callback redirects
 * It should be rendered in the main App to catch the auth tokens from URL hash
 */
export function AuthCallbackHandler() {
    const navigate = useNavigate();
    const location = useLocation();
    const processedRef = useRef(false);

    useEffect(() => {
        // Prevent double processing in React StrictMode
        if (processedRef.current) return;

        const hash = window.location.hash;

        // Check for OAuth callback (contains access_token)
        if (hash && hash.includes('access_token')) {
            processedRef.current = true;
            console.log('OAuth callback detected');

            // Give Supabase time to process the hash automatically
            // The onAuthStateChange in AuthContext will handle the session
            setTimeout(() => {
                // Clear the hash from URL
                window.history.replaceState(null, '', window.location.pathname);
                console.log('OAuth hash cleared, waiting for auth state...');
            }, 500);
        }

        // Check for password reset callback (type=recovery)
        if (hash && hash.includes('type=recovery')) {
            processedRef.current = true;
            console.log('Password reset callback detected');
            // Wait a bit for Supabase to process, then navigate
            setTimeout(() => {
                navigate('/reset-password', { replace: true });
            }, 500);
        }
    }, [location, navigate]);

    // This component doesn't render anything
    return null;
}
